import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';
import { HERO_IMAGE } from '../mock';
import Marquee from './Marquee';

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-[var(--bg)] pt-20 pb-10 border-t border-[var(--border)] z-[2000]">
      <Marquee items={['Maycon Robert', 'Maycon Robert', 'Maycon Robert', 'Maycon Robert']} speed={8} className="mb-16 py-8 border-y border-[var(--border)]" />


      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-start gap-5">
            <img src={HERO_IMAGE} alt="Maycon" loading="lazy" decoding="async" width={80} height={96} className="w-20 h-24 object-cover rounded-md" />
            <div>
              <div className="font-display text-xl">Maycon Robert</div>
              <div className="text-white/60 text-sm mt-1">Designer Gráfico e Web</div>
              <div className="text-white/60 text-sm mt-3 max-w-xs">
                R. Professora Lucinda Tamborini - 227 - Res. Cidade Universitária - Alfenas-MG
              </div>
              <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox" target="_blank" rel="noopener noreferrer" className="inline-block mt-4 text-sm tracking-[0.25em] text-white hover:text-[var(--accent)]">
                maycom.robert@gmail.com →
              </a>

            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.3em] text-white/40 mb-4">NAVEGAÇÃO</div>
          <ul className="space-y-2 text-sm">
            {[
              { l: 'INÍCIO', id: 'home' },
              { l: 'SOBRE', id: 'about' },
              { l: 'PROJETOS', id: 'works' },
              { l: 'HABILIDADES', id: 'solutions' },
              { l: 'CONTATO', id: 'contact' }
            ].map(({ l, id }) => (
              <li key={l}>
                <a href={`#${id}`} className="hover:text-[var(--accent)] transition-colors tracking-[0.2em]">
                  {l}
                </a>

              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs tracking-[0.3em] text-white/40 mb-4">REDES SOCIAIS</div>
          <div className="flex gap-3">
            {[
              { 
                Icon: Instagram, 
                href: 'https://www.instagram.com/mayrobert01/', 
                label: 'Instagram' 
              },
              { 
                Icon: () => (
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M22 13h-5v1.3c0 .8.6 1.1 1.2 1.1.8 0 1.2-.5 1.2-1.3h2.6c0 2.3-1.6 3.9-3.9 3.9-2.3 0-3.8-1.5-3.8-3.9s1.4-3.9 3.8-3.9 3.9 1.5 3.9 3.9v.3zm-3.8-1.7c-.5 0-1.1.2-1.1.9h2.3c0-.7-.6-.9-1.2-.9zM9.8 19H2V5h7.2c3.4 0 4.2 1.9 4.2 3.1 0 1.1-.6 2.3-2.3 2.8 1.9.3 2.9 1.6 2.9 3.2 0 1.7-1 4.9-4.2 4.9zM5 8.1v2.7h2.1c1.2 0 1.8-.5 1.8-1.3 0-1-.6-1.4-1.8-1.4H5zm0 5.4v2.7h2.2c1.4 0 2-.6 2-1.4 0-.9-.6-1.3-2-1.3H5zM21.2 8h-4.4V6h4.4v2z"/>
                  </svg>
                ), 
                href: 'https://www.behance.net/mroliveira', 
                label: 'Behance' 
              },
              { 
                Icon: Linkedin, 
                href: 'https://www.linkedin.com/in/mayconrobert/', 
                label: 'LinkedIn' 
              },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-11 h-11 rounded-full border border-[var(--border)] flex items-center justify-center hover:bg-[var(--accent)] hover:border-[var(--accent)] transition-colors group"
              >
                <div className="group-hover:scale-110 transition-transform">
                  <Icon size={18} strokeWidth={1.5} />
                </div>
              </a>
            ))}
          </div>
          <div className="mt-8 text-xs text-white/40">© 2026 Todos os direitos reservados</div>
        </div>
      </div>
    </footer>
  );
}
